<template>
  <v-container class="ma-0 pa-0" width="100%">
    <!-- list app bar-->
    <v-container
      v-if="!secondary"
      flat
      dense
      class="ma-0 pa-0 d-flex justify-space-between"
      width="100%"
      height="45"
    >
      <!-- right side-->
      <v-container class="pa-0 ma-0 d-flex right">
        <v-toolbar-title class="ma-0 pa-0 mt-1">{{
          titleProp ? $t(titleProp) : $t($route.name, { name: $store.state.studentLabel })
        }}</v-toolbar-title>
        <v-text-field
          class="ms-2"
          v-if="!isMobile && !isTablet"
          style="width: 230px"
          v-model="search"
          append-icon="mdi-magnify"
          clearable
          :label="$t('search')"
          flat
          outlined
          dense
        />
      </v-container>
      <!-- left side-->
      <v-container class="pa-0 ma-0 d-flex right">
        <v-btn
          v-if="deleteShow"
          outlined
          @click="deleteSelected()"
          class="px-1 me-1 pa-0"
          color="pink"
          height="32"
        >
          <p class="font-weight-thin mb-0 me-2">
            {{ $t("remove") }}
          </p>
          <v-icon> mdi-trash-can-outline </v-icon>
        </v-btn>
        <v-menu offset-y v-if="isMobile || isTablet">
          <template v-slot:activator="{ attrs, on }">
            <v-btn
              outlined
              class="px-1"
              color="grey darken-2"
              height="32"
              v-bind="attrs"
              v-on="on"
              style="min-width: 35px !important; padding: 0 !important"
            >
              <v-icon> mdi-dots-vertical </v-icon>
            </v-btn>
          </template>
          <v-list dense>
            <v-list-item link @click="getItems">
              <v-list-item-icon>
                <v-icon>mdi-refresh</v-icon>
              </v-list-item-icon>
              <v-list-item-title v-text="$t('refresh')" />
            </v-list-item>
            <v-list-item link>
              <export-excel
                ref="refExcel"
                :data="baseData"
                worksheet="abriron.com"
                name="data.xls"
                type="xls"
                class="d-flex align-center w-100"
                :title="$store.state.abrName"
                :total-prop="pageCount"
                :page-prop="excelPage"
                @getAllRows="getAllRows"
              >
                <v-list-item-icon>
                  <v-icon>mdi-file-excel-outline</v-icon>
                </v-list-item-icon>
                <v-list-item-title>{{ $t("excel") }}</v-list-item-title>
              </export-excel>
            </v-list-item>
            <v-list-item v-if="isMobile || isTablet" link @click="printDialog = true">
              <v-list-item-icon>
                <v-icon>mdi-printer-outline</v-icon>
              </v-list-item-icon>
              <v-list-item-title v-text="$t('print')" />
            </v-list-item>
            <v-list-item link @click="goToContract">
              <v-list-item-icon>
                <v-icon>mdi-plus</v-icon>
              </v-list-item-icon>
              <v-list-item-title v-text="$t('new_contract')" />
            </v-list-item>
          </v-list>
        </v-menu>

        <v-btn
          v-if="!isMobile && !isTablet"
          @click="getItems"
          outlined
          class="px-1 ms-2 pa-0"
          color="grey darken-2"
          height="32"
          @shortkey="getItems"
          v-shortkey="['f5']"
          style="min-width: 35px !important; padding: 0 !important"
        >
          <v-icon> mdi-refresh </v-icon>
        </v-btn>
        <export-excel
          v-if="!isMobile && !isTablet"
          ref="refExcel"
          :data="baseData"
          worksheet="abriron.com"
          name="data-ai.xls"
          type="xls"
          class="float-left pa-0 ma-0"
          :title="$store.state.abrName"
          :total-prop="pageCount"
          :page-prop="excelPage"
          @getAllRows="getAllRows"
        >
          <v-btn outlined class="ma-0 ms-2" color="grey darken-2 " height="32">
            <p class="font-weight-thin mb-0 pa-a me-2">
              {{ $t("excel") }}
            </p>
            <v-icon> mdi-file-excel-outline </v-icon>
          </v-btn>
        </export-excel>
        <v-btn
          v-if="!isMobile && !isTablet"
          outlined
          @click="printDialog = true"
          class="ms-2 pa-0"
          color="grey darken-2"
          height="32"
        >
          <p class="font-weight-thin mb-0 me-2">
            {{ $t("print") }}
          </p>
          <v-icon> mdi-printer-outline </v-icon>
        </v-btn>
        <v-btn
          v-if="!isMobile && !isTablet"
          @click="goToContract"
          class="ms-2 pa-0"
          color="primary"
          height="32"
        >
          {{ $t("new_contract") }}

          <v-icon color="#fff"> mdi-plus </v-icon>
        </v-btn>
      </v-container>
    </v-container>

    <!-- secondary app bar-->
    <v-container
      v-if="secondary"
      flat
      dense
      class="ma-0 pa-0 d-flex justify-space-between"
      width="100%"
      height="45"
    >
      <v-container class="pa-0 ma-0 d-flex right">
        <v-toolbar-title class="ma-0 pa-0">
          {{
            titleProp
              ? $t(titleProp)
              : $t($route.name, { name: $store.state.studentLabel })
          }}
        </v-toolbar-title>
      </v-container>
      <!-- left side-->
      <v-container class="pa-0 ma-0 d-flex right">
        <v-btn
          v-if="!show"
          outlined
          :loading="loader"
          @click="preview()"
          class="ms-2 pa-0"
          color="primary"
          height="32"
        >
          <p class="font-weight-thin mb-0 pl-1">
            {{ $t("preview") }}
          </p>
        </v-btn>
        <v-btn
          v-if="show"
          :loading="loader"
          @click="back()"
          class="ms-2 pa-0"
          color="primary"
          height="32"
        >
          <p class="font-weight-thin mb-0 pl-1">
            {{ $t("return-to-previous-page") }}
          </p>
        </v-btn>
        <v-btn
          v-if="!show"
          outlined
          :loading="loader"
          @click="saveAndNew()"
          class="ms-2 pa-0"
          color="primary"
          height="32"
        >
          <p v-if="!edit" class="font-weight-thin mb-0 pl-1">
            {{ $t("Save and new") }}
          </p>
          <p v-if="edit" class="font-weight-thin mb-0 pl-1">
            {{ $t("Save") }}
          </p>
        </v-btn>
        <v-btn
          v-if="!show"
          :loading="loader"
          @click="saveAndReturn()"
          class="ms-2 pa-0"
          color="primary"
          height="32"
        >
          {{ $t("Save and Return") }}
        </v-btn>
      </v-container>
    </v-container>

    <!--excel dialog-->
    <v-dialog
      v-model="printDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="90%"
    >
      <v-card>
        <v-col class="d-flex pb-0">
          <v-btn icon color="grey darken-2" @click="printDialog = false">
            <v-icon class="close-hover" large> mdi-close </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t("print") }}
          </p>
        </v-col>
        <v-row class="ma-0">
          <printnew
            ref="printRef"
            :header-prop="printHeaders"
            :items-prop="items"
            :dialog="printDialog"
            :title="$t($route.name)"
          />
        </v-row>
        <v-card-actions />
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
export default {
  name: "appBar",
  props: {
    secondary: {
      type: Boolean,
      default: false,
    },
    edit: {
      type: Boolean,
      default: false,
    },
    deleteShow: {
      type: Boolean,
      default: false,
    },
    workshopItems: {
      type: Object,
      default: () => {},
    },
    loader: {
      type: Boolean,
      default: false,
    },
    showPreview: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    workshopItems: {
      deep: true,
      handler(val) {
        if (val) {
          let data = JSON.parse(JSON.stringify(val));
          this.items = data.items.data || [];
          this.baseData = data.items.data || [];
          this.pageCount = data.items.last_page || 0;
          this.excelPage = data.items.current_page || 1;
        }
      },
    },
    loader: {
      deep: true,
      handler(val) {
        if (val) {
          this.loading = val;
        }
      },
    },
    showPreview: {
      deep: true,
      handler(newVal) {
        if (newVal) {
          this.show = true;
        }
      },
    },
  },
  components: {},
  data: () => ({
    show: false,
    titleProp: "",
    printHeaders: "",
    search: null,
    printDialog: false,
    baseData: null,
    pageCount: null,
    excelPage: null,
    loading: false,
    show: false,
    items: [],
  }),
  beforeMount() {
    this.printHeaders = [
      { text: this.$t("id"), value: "id" },
      { text: this.$t("workshopName"), value: "name" },
      { text: this.$t("CoFunder"), value: "employer_name" },
      { text: this.$t("countPersonnel"), value: "insurance_code" },
      { text: this.$t("workshopCode"), value: "insurance_code" },
    ];
  },

  methods: {
    deleteSelected() {
      this.$emit("delete-selected");
    },
    back() {
      this.show = false;
      this.$emit("back");
    },
    openUploadDialog() {},
    goToContract() {
      this.$router.push("/payroll/contract/create");
    },
    saveAndNew() {
      this.$emit("click-save-and-new");
    },
    saveAndReturn() {
      this.$emit("click-save-and-return");
    },
    preview() {
      this.show = true;
      this.$emit("preview");
    },
    openFilters() {
      this.$emit("open-filters");
    },
    getItems() {
      this.$emit("get-items");
    },
  },
};
</script>
<style scoped>
.right {
  width: auto;
}
</style>
